import "./inputWithError.css";
import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import { isFieldWrong } from "../../common/lib/validationAllFields";
import ReactPopover from "react-popover";
let Popover = React.createFactory(ReactPopover);

export default class InputWithError extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired
  };

  static defaultProps = {
    type: "text"
  };

  constructor(props) {
    super(props);

    this.timeoutTime = 300;
    this.timeout = null;
  }

  onErrorMouseOver = (form, key) => {
    const { actions, feature } = this.props;
    actions.setIsFormErrorVisible(feature, form, key, true);
  };

  onErrorMouseOut = (form, key) => {
    const { actions, feature } = this.props;

    actions.setIsFormErrorVisible(feature, form, key, false);
  };

  onChange = (form, name, { target: { value } }) => {
    const { actions, feature, validateFormField } = this.props;

    actions.setFormField(feature, form, name, value);

    // real-time validation
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      validateFormField(form, name, value).then(({ error, payload }) => {
        if (error) {
          actions.setFormError(feature, form, payload, name);
        } else {
          actions.clearFormError(feature, form, name);
        }
      });
    }, this.timeoutTime);
  };

  getError = key => {
    const { form, formName } = this.props;

    if (form.errors.size === 0) {
      return;
    }

    let field = form.errors.get(key);
    if (field.length == 0) {
      return;
    }
    let err = "";
    for (let i = 0; i < field.length; i++) {
      err += field[i].msg;
    }
    let popoverProps = {
      isOpen: form.isErrorVisible.get(key),
      preferPlace: "right",
      refreshIntervalMs: 10,
      className: "form-popover",
      body: [<div className="tooltip">{err}</div>]
    };

    return Popover(
      popoverProps,
      <i
        onTouchTap={this.onErrorMouseOver.bind(this, formName, key)}
        onClick={this.onErrorMouseOver.bind(this, formName, key)}
        onMouseOver={this.onErrorMouseOver.bind(this, formName, key)}
        onMouseOut={this.onErrorMouseOut.bind(this, formName, key)}
        className="glyphicon glyphicon-warning-sign"
      />
    );
  };

  render() {
    const {
      field,
      actions,
      form,
      formName,
      disabled,
      type,
      onClick,
      feature,
      className,
      placeholder
    } = this.props;

    let d = disabled;
    if (d === undefined) {
      d = form.disabled;
    }

    return (
      <div className="inner-addon right-addon">
        <input
          type={type}
          id={field}
          name={field}
          className={
            isFieldWrong(form.errors, field) + " " + className ? className : ""
          }
          onChange={this.onChange.bind(this, formName, field)}
          onFocus={this.onErrorMouseOver.bind(this, formName, field)}
          onBlur={this.onErrorMouseOut.bind(this, formName, field)}
          placeholder={placeholder}
          value={form.fields[field] || form.fields.getIn(field)}
          disabled={d}
          onClick={onClick}
        />
        {isFieldWrong(form.errors, field) && this.getError(field)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/inputWithError.react.js